#import "../fragments/account-attachments-fragment.graphql"

query GetAttachmentsForAccount($accountId: ID!) {
    account(id: $accountId) {
        ...AccountAttachmentsFragment
    }
}
